import WebAPI from "./WebAPI";
import { postMessageToParent } from "../Utils";
import { PostMessage } from "../../constants/chat";

export default (() => {
    const webApi = new WebAPI();
    const eventEmitter = webApi.eventEmitter;
    eventEmitter.on("session-reset", () => {
        postMessageToParent(PostMessage.SESSION_RESET, {});
    });

    const head = (url, options) => webApi.createRequest("head", url, options);

    const get = (url, options) => webApi.createRequest("get", url, options);

    const post = (url, options) => webApi.createRequest("post", url, options);

    const put = (url, options) => webApi.createRequest("put", url, options);

    const abortAllRequests = () => webApi.abortAllRequests();

    return { head, get, post, put, abortAllRequests, eventEmitter };
})();
